import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { apiClient } from "@/lib/api";

const defaultForm = {
  name: "",
  company: "",
  email: "",
  specialization: "",
  message: "",
};

export const RecruiterNetworkPage = () => {
  const [formData, setFormData] = useState(defaultForm);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setIsError(false);
    setResponseMessage("");

    try {
      await apiClient.post("/recruiter_inquiry.php", formData);
      setResponseMessage("Thanks for applying. Our partnerships team will connect with you shortly.");
      setFormData(defaultForm);
    } catch (error) {
      setIsError(true);
      setResponseMessage("Unable to submit at this moment. Please try again.");
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mx-auto max-w-7xl space-y-8 px-6 pb-20 pt-16 md:px-10" data-testid="recruiter-network-page-wrapper">
      <section data-testid="recruiter-network-hero">
        <p className="text-sm uppercase tracking-[0.2em] text-[#6FE3C1]" data-testid="recruiter-network-kicker">Recruiter Network</p>
        <h1 className="mt-4 text-4xl font-bold md:text-5xl" data-testid="recruiter-network-heading">Join the Recruiter Network</h1>
        <p className="mt-4 max-w-3xl text-[#D9E1E8]/80" data-testid="recruiter-network-description">
          Independent recruiters and vendors can submit candidates through the platform and earn commissions when candidates are hired.
        </p>
      </section>

      <form onSubmit={handleSubmit} className="glass-panel max-w-3xl space-y-5 rounded-2xl p-6 md:p-8" data-testid="recruiter-network-form">
        <div className="grid gap-4 md:grid-cols-2">
          <Input name="name" value={formData.name} onChange={handleChange} required placeholder="Full Name" data-testid="recruiter-form-name-input" className="border-white/20" />
          <Input name="company" value={formData.company} onChange={handleChange} required placeholder="Agency / Company" data-testid="recruiter-form-company-input" className="border-white/20" />
          <Input name="email" type="email" value={formData.email} onChange={handleChange} required placeholder="Work Email" data-testid="recruiter-form-email-input" className="border-white/20" />
          <Input name="specialization" value={formData.specialization} onChange={handleChange} required placeholder="Specialization" data-testid="recruiter-form-specialization-input" className="border-white/20" />
        </div>

        <Textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          placeholder="Tell us about your candidate network and roles you recruit for"
          className="min-h-[120px] border-white/20"
          data-testid="recruiter-form-message-input"
        />

        <Button type="submit" disabled={isSubmitting} className="bg-[#2EC4A6] text-[#071A2C] hover:bg-[#6FE3C1]" data-testid="recruiter-form-submit-button">
          {isSubmitting ? "Submitting..." : "Join as a Recruiter"}
        </Button>

        {responseMessage ? (
          <p className={`text-sm ${isError ? "text-red-400" : "text-[#6FE3C1]"}`} data-testid="recruiter-form-response-message">
            {responseMessage}
          </p>
        ) : null}
      </form>
    </div>
  );
};
